import { goBackOrDefaultUrl } from "common/utils/browser";
import initAccordion from "components/supplier_admin/shared/accordion/accordion";
import { requestSignal } from "components/supplier_admin/assembly_queue/assembly_queue_api";
import {
  clearButtonLoading,
  setButtonLoading
} from "components/supplier_admin/shared/action_button/action_button_loading";

const SELECTORS = {
  actionButton: ".js-assembly-queue-show-action",
  container: ".assembly-queue-show",
  backLink: ".js-back-link-history"
};

const initBackNavigation = () => {
  const $backLink = document.querySelector(SELECTORS.backLink);
  if ($backLink) {
    $backLink.addEventListener("click", e => {
      e.preventDefault();
      goBackOrDefaultUrl($backLink.getAttribute("href"));
    });
  }
};

const initAssemblyQueueShow = () => {
  const $container = document.querySelector(SELECTORS.container);
  if ($container) {
    initAccordion($container);
    initBackNavigation();

    const $actionButton = $container.querySelector(SELECTORS.actionButton);
    if ($actionButton) {
      $actionButton.addEventListener("click", async () => {
        const { shipmentId, signalType } = $actionButton.dataset;
        if (!shipmentId || !signalType) return;

        setButtonLoading($actionButton);
        try {
          await requestSignal({ shipmentId, signalType });
          window.location.reload();
        } catch (error) {
          console.error("[Assembly PDP] Signal request failed.", error);
          clearButtonLoading($actionButton);
        }
      });
    }
  }
};

document.addEventListener("DOMContentLoaded", initAssemblyQueueShow);
